<div class="calendar-view" [style.max-height]="maxHeight">
    <div class="calendar-items">
        @if (calendar) {
            @if (calendar.days.length === 0) {
                <div class="calendar-empty">
                    <div class="done-visual">
                        <div class="line"><hr /></div>

                        <div class="check">
                            <i class="fal fa-check-circle"></i>
                        </div>

                        <div class="line"><hr /></div>
                    </div>

                    <p>You're All Caught Up!</p>
                </div>
            } @else if (calendar.days.length > 0) {
                @for (day of calendar.days; track day) {
                    <div class="detail-page-card">
                        <div class="detail-page-card-title">{{ day.name }}</div>
                        <div
                            class="detail-page-card-body cerrix-control-sm list-group list-group-flush"
                        >
                            @for (item of day.items; track item) {
                                <div
                                    class="list-group-item list-group-item-action"
                                    (click)="openItem(item)"
                                >
                                    <div class="title">
                                        <span class="name" [title]="item.name">
                                            {{ item.name }}
                                        </span>
                                        <small class="time-indication" [class.red]="day.isOverdue">
                                            {{ item.timeframe }}
                                        </small>
                                    </div>
                                    <p class="description text-truncate" [title]="item.description">
                                        {{ item.description }}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                }
            }
        } @else {
            <div class="calendar-loading">
                <div class="fancy-loader submodule"></div>
            </div>
        }
    </div>

    @if (showActions) {
        <div class="calendar-actions">
            <div class="calendar-action" (click)="reload(true)" [disabled]="!calendar">
                <i class="fas fa-sync" [class.fa-spin]="!calendar"></i>
            </div>

            <div class="calendar-action" (click)="openTab(pages.Calendar)">
                <i class="fas fa-calendar"></i>
            </div>

            <div class="calendar-action" (click)="openTab(pages.CalendarSettings)">
                <i class="fas fa-cog"></i>
            </div>
        </div>
    }
</div>
